import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
var render = function render(_c, _vm) {
  return _vm.props.user && _vm.$options.m.status(_vm.props) !== '' ? _c('span', {
    staticClass: "kiwi-typingstatusindicator kiwi-typing",
    class: _defineProperty({
      'kiwi-typingstatusindicator--paused': _vm.$options.m.status(_vm.props) === 'paused'
    }, _vm.data.staticClass, true)
  }) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };